export default function AbsenDokter() {
    return {
        id: null,
        jadwal:{
            id: null
        },
        status: "CANCELLED",
        tanggal: null
    };
}